<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <ExpoTopOffer />
      <ExpoCategoriesCards 
        v-on:navigate="navigate($event)" 
        :customerInfo="customerInfo"/>
      <component
          :is="contentComponent"
          @updated="contentUpdated"
          :customerInfo="customerInfo"
          :perksCardsData="perksCardsData"
          :id="id"
          :customerSubscriptionDetails="customerSubscriptionDetails"
          :customerLastSubscription="customerLastSubscription"
      />
    </div>
  </b-container>
</template>

<script>
import dropImage from "@/assets/images/centre/temporaryImgGrayDrop.png"; 

import ExpoTopOffer from "@/components/centre/expo/ExpoTopOffer.vue";
import ExpoCategoriesCards from "@/components/centre/expo/ExpoCategoriesCards.vue";
import ExpoShowAllCards from "@/components/centre/expo/ExpoShowAllCards.vue";

import ExpoBooksImg from "@/assets/images/centre/expo/expo-cards/Expo-Books-Coming-soon.png";
import ExpoJournalsImg from "@/assets/images/centre/expo/expo-cards/Expo-Journals-Coming-soon.png";
import ExpoSummitImg from "@/assets/images/centre/expo/expo-cards/Expo-Summit-Coming-soon.png";
import ExpoKcEmotionalImg from "@/assets/images/centre/expo/expo-cards/Expo-Kc-Emotional-Intelligence.png";
import ExpoKcClarityImg from "@/assets/images/centre/expo/expo-cards/Expo-Kc-Clarity-and-confidence.png";
import ExpoKcBusinessImg from "@/assets/images/centre/expo/expo-cards/Expo-Kc-6-month-Business.png";
import ExpoAmyInActionImg from "@/assets/images/centre/expo/expo-cards/Expo-Amy-Aromatherapy-in-Action.png";
import ExpoAmyTeachingImg from "@/assets/images/centre/expo/expo-cards/Expo-Amy-Galper-Aromatherapy-Teaching-101.png";
import ExpoAmyBusinessImg from "@/assets/images/centre/expo/expo-cards/Expo-Amy-Galper-Build-Your-Aromatherapy-Business.png";

import modernCosmeticsImg from "@/assets/images/centre/perks/perks-cards/ModernCosmetics.png";
import aromaEmpressImg from "@/assets/images/centre/perks/perks-cards/AromaEmpress.png";
// import dressToProgressImg from "@/assets/images/centre/perks/perks-cards/DressToProgress.png";
import productCertificationImg from "@/assets/images/centre/perks/perks-cards/ProductCertification.png";
import gcAnalysisImg from "@/assets/images/centre/perks/perks-cards/GCAnalysis.png";
// import melissaImg from "@/assets/images/centre/perks/perks-cards/Melissa.png";
import perksDropsmartProfileJoyImg from "@/assets/images/centre/perks/perks-cards/PerksDropsmartProfileJoy.png";
import perksNextLevelImg from "@/assets/images/centre/perks/perks-cards/PerksNextLevel.png";
// import whoImg from "@/assets/images/centre/perks/perks-cards/Who.png";
import ComingSoonBadge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Coming-soon.png";
import SpecialGiftBadge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Special-Gift.png";
// import Perks10Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-10.png";
// import Perks15Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-15.png";
// import Perks20Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-20.png";
// import Perks25Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-25.png";
// import Perks30Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-30.png";
// import Perks35Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-35.png";
// import Perks40Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-40.png";
// import Perks45Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-45.png";
// import Perks50Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-50.png";
// import Perks75Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-75.png";
// import PerksGift10Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-10.png";
// import PerksGift15Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-15.png";
// import PerksGift20Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-20.png";
// import PerksGift25Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-25.png";
// import PerksGift30Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-30.png";
// import PerksGift35Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-35.png";
// import PerksGift40Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-40.png";
// import PerksGift45Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-45.png";
// import PerksGift50Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-50.png";
// import PerksGift75Badge from "@/assets/images/centre/perks/perks-cards/badges/Perks-Gift-75.png";
import marvaImg from "@/assets/images/centre/perks/perks-modal/MarvaImg.png";

import AromaEmpressModalImg from "@/assets/images/centre/perks/perks-modal/Aroma-Empress-pop-up.png";
import ModernCosmeticsModalImg from "@/assets/images/centre/perks/perks-modal/Modern-cosmetics-pop-up.png";
// import NextLevelModalImg from "@/assets/images/centre/perks/perks-modal/Next-Level-Program-pop-up.png";
import CarolImg from "@/assets/powerdrops/testimonial-carol-rose.png";
import SharonImg from "@/assets/images/centre/perks/perks-modal/Sharon-CassanoLochman.jpeg";


export default {
  title: "Center Expo",
  name: "Expo",
  props: ["page", "customerInfo", "id", "customerSubscriptionDetails", "customerLastSubscription"],
  components: {
    ExpoTopOffer,
    ExpoCategoriesCards,
    ExpoShowAllCards,
  },
  mounted() {
    let target = this.page ? this.page : "ExpoShowAllCards";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      // possible categories by now: Education / Business / Surprise
      perksAllCardsData: [
        {
          id: 1,
          hasModal: false,
          category: "Education",
          productTitle: "How Essential Oils Work",
          description: "by Dr E. Joy Bowles",
          cardImage: perksDropsmartProfileJoyImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/joy-bowles/how-eos-work",
          modalTitle: "How essential oils work",
          modalSubtitle: "by Dr. Joy Bowles",
          leftButton: "Click to check it out.",
          modalImage: dropImage,
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: CarolImg,
              reviewName: "Carol Rose BSc (HONS) Pall Nurs, RGN, Dip Aroma, RMT",
              reviewDescription: "Clinical Aromatherapist & Educator | Owner of The Aromary",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: '"What a privilege to “attend” Joy Bowles’ webinar series “How Aromatherapy Works”. The subject of how essential oil constituents interact with the body can at times, feel confusing and overwhelming.'
              },
              {
                paragraphId: 2,
                paragraphText: 'Using a step-by-step approach, Joy explains the mechanisms and processes that take place at a cellular level with each webinar building on the last to create a clear & concise picture. As well as possessing an exceptional knowledge base, Joy has a natural on-screen presence with an engaging teaching style that held my attention for every session.'
              },
              {
                paragraphId: 3,
                paragraphText: 'She is highly skilled at “translating complex information” into an easy-to-understand form. For me, this series highlights how crucial it is, as practicing Aromatherapists, to document & share our clinical findings to establish a deeper understanding of these complex interactions and the therapeutic effects essential oils have on the human body.'
              },
              {
                paragraphId: 4,
                paragraphText: 'This webinar series by Joy Bowles is one I would highly recommend to anyone with a serious interest in Aromatherapy."'
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: null, //no discount
            freeBadge: SpecialGiftBadge, //10 percentage
            monthlyBadge: SpecialGiftBadge, //20 percentage monthly or trial
            yearlyBadge: SpecialGiftBadge, //30 percentage + gift
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPHJOOQ',
            monthlyCoupom: '20TPHUUG',
            yearlyCoupom: '30TPYAAY',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off plus 30min Q&A with Dr. Joy',
          },
          showOnDeck: true,
        },
        {
          id: 2,
          hasModal: false,
          category: "Education",
          productTitle: "Next Level",
          description: "by Melani Kovac",
          cardImage: perksNextLevelImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/melani/next-level-program",
          modalTitle: "",
          modalSubtitle: "",
          leftButton: "",
          modalImage: dropImage,
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, //no discount
            freeBadge: SpecialGiftBadge, //10 percentage
            monthlyBadge: SpecialGiftBadge, //20 percentage monthly or trial
            yearlyBadge: SpecialGiftBadge, //30 percentage + gift
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPGQYD',
            monthlyCoupom: '20TPIAWM',
            yearlyCoupom: '30TPYXGR',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: true,

        },
        {
          id: 3,
          hasModal: false,
          category: ["Education", "Business"], 
          productTitle: "Build Your Aromatherapy Business",
          description: "by Amy Galper",
          cardImage: ExpoAmyBusinessImg,  
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/amy-galper/build-your-aromatherapy-business",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, 
            freeBadge: SpecialGiftBadge, 
            monthlyBadge: SpecialGiftBadge, 
            yearlyBadge: SpecialGiftBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 4,
          hasModal: false,
          category: "Business", 
          productTitle: "Clarity & Confidence",
          description: "by Kc Rossi",
          cardImage: ExpoKcClarityImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/kc-rossi/Clarity-and-Confidence",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, 
            freeBadge: SpecialGiftBadge, 
            monthlyBadge: SpecialGiftBadge, 
            yearlyBadge: SpecialGiftBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 5,
          hasModal: false,
          category: "Education", 
          productTitle: "Aromatherapy in Action",
          description: "by Amy Galper",
          cardImage: ExpoAmyInActionImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/amy-galper/aromatherapy-in-action",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, 
            freeBadge: SpecialGiftBadge, 
            monthlyBadge: SpecialGiftBadge, 
            yearlyBadge: SpecialGiftBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 6,
          hasModal: false,
          category: "Business", 
          productTitle: "Increase Your Emotional Intelligence Package",
          description: "by Kc Rossi",
          cardImage: ExpoKcEmotionalImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/kc-rossi/Emotional-Intelligence",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, 
            freeBadge: SpecialGiftBadge, 
            monthlyBadge: SpecialGiftBadge, 
            yearlyBadge: SpecialGiftBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 7,
          hasModal: false,
          category: "Education",
          productTitle: "Modern Cosmetics",
          description: "50 pages of fantastic info on natural cosmetic ingredients",
          cardImage: modernCosmeticsImg,
          ontraportUrl: "",
          externalUrl: "",
          modalTitle: "Modern Cosmetics",
          modalSubtitle: "Modern Cosmetics is the world’s most comprehensive book on cosmetic ingredients of natural origin.",
          leftButton: "Click to check it out.",
          modalImage: ModernCosmeticsModalImg,
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, //no discount
            freeBadge: ComingSoonBadge, //10 percentage
            monthlyBadge: ComingSoonBadge, //20 percentage monthly or trial
            yearlyBadge: ComingSoonBadge, //30 percentage + gift
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPHJOOQ',
            monthlyCoupom: '20TPHUUG',
            yearlyCoupom: '30TPYAAY',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: true,
        },
        {
          id: 8,
          hasModal: false,
          category: "Education",
          productTitle: "Aroma Empress",
          description: "by Melani Kovac",
          cardImage: aromaEmpressImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/melani/aroma-empress",
          modalTitle: "Aroma Empress",
          modalSubtitle: "A course created for aromatherapy leaders. For those who want more!",
          leftButton: "Click to check it out.",
          modalImage: AromaEmpressModalImg,
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: marvaImg,
              reviewName: "Marva Watkins",
              reviewDescription: "Aromatherapy Student",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: '"This is wonderful. It is really reinforcing the information you have given in your other classes and is helping me to understand more fully how to organize my thought process. So looking forward to more of what you have to give. Thank you for the simplicity and clarity.'
              },
              {
                paragraphId: 2,
                paragraphText: 'Melani, I have so enjoyed this course. I will be constantly reviewing and implementing what I have learned until I have mastered the principles to the degree that I feel comfortable with my blending. It is a process that will only come with trial and experience. Thank you so much for sharing, especially your one-on-one tips."'
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: null, //no discount
            freeBadge: SpecialGiftBadge, //10 percentage
            monthlyBadge: SpecialGiftBadge, //20 percentage monthly or trial
            yearlyBadge: SpecialGiftBadge, //30 percentage
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPGQYD',
            monthlyCoupom: '20TPIAWM',
            yearlyCoupom: '30TPYXGR',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: true,
        },
        {
          id: 9,
          hasModal: false,
          category: "Surprise",
          productTitle: "Product certification",
          description: "Surprise",
          cardImage: productCertificationImg,
          ontraportUrl: "",
          externalUrl: "",
          modalSubtitle: "",
          leftButton: "Click to check it out.",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, //no discount
            freeBadge: ComingSoonBadge, //10 percentage
            monthlyBadge: ComingSoonBadge, //20 percentage monthly or trial
            yearlyBadge: ComingSoonBadge, //30 percentage + gift
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPHJOOQ',
            monthlyCoupom: '20TPHUUG',
            yearlyCoupom: '30TPYAAY',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: true,
        },
        {
          id: 10,
          hasModal: false,
          category: "Education", 
          productTitle: "Aromatherapy Teacher Training",
          description: "by Amy Galper",
          cardImage: ExpoAmyTeachingImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/amy-galper/aromatherapy-teacher-training",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, 
            freeBadge: SpecialGiftBadge, 
            monthlyBadge: SpecialGiftBadge, 
            yearlyBadge: SpecialGiftBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 11,
          hasModal: false,
          category: "Education", 
          productTitle: "Books",
          description: "Coming soon!",
          cardImage: ExpoBooksImg,
          ontraportUrl: "",
          externalUrl: "",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, 
            freeBadge: ComingSoonBadge, 
            monthlyBadge: ComingSoonBadge, 
            yearlyBadge: ComingSoonBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 12,
          hasModal: false,
          category: "Business", 
          productTitle: "6-month Business Consulting & Performance Coaching",
          description: " by Kc Rossi",
          cardImage: ExpoKcBusinessImg,
          ontraportUrl: "",
          externalUrl: "https://expo.dropsmarteo.com/kc-rossi/Consulting-and-Coaching",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, 
            freeBadge: SpecialGiftBadge, 
            monthlyBadge: SpecialGiftBadge, 
            yearlyBadge: SpecialGiftBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 13,
          hasModal: false,
          category: "Education", 
          productTitle: "Summit",
          description: "Coming soon!",
          cardImage: ExpoSummitImg,
          ontraportUrl: "",
          externalUrl: "",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, 
            freeBadge: ComingSoonBadge, 
            monthlyBadge: ComingSoonBadge, 
            yearlyBadge: ComingSoonBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
        {
          id: 14,
          hasModal: false,
          category: "Business",
          productTitle: "Clarity & Confidence",
          description: "by Kc Rossi",
          cardImage: "",
          ontraportUrl: "",
          externalUrl: "",
          modalTitle: "Clarity & Confidence",
          modalSubtitle: "One-Hour Single Session",
          leftButton: "Click to check it out.",
          modalImage: dropImage,
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: SharonImg,
              reviewName: "Sharon CassanoLochman",
              reviewDescription: "#1 Best-selling Author, Writing Coach",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: '"I enrolled in Kc Rossi’s coaching program because she offered the tools I needed for success under one platform. It was clear I needed help. I was spread thin over several websites without a cohesive link. I was drowning in marketing strategies as I struggled with unrealized goals and earning potential. I met Kc through a Women’s Network. She was upbeat, a great listener, and genuinely sincere. She invited me to follow her Facebook page, and shortly after that, I booked a call, which would ultimately mark a pivotal point in my life both professionally and personally. Kc gently guided me through an intense and rewarding revitalization of my business framework through her holistic approach that nudged me in directions I never thought possible. She ushered forth loads of self-worth strategies that supported the whole of me through her top-notch coaching program before releasing the most impressive web design and branding. Through Kc’s coaching program, I have blossomed into a leading authority in my field of expertise as I help aspiring authors realize their writing dreams."'
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, 
            freeBadge: ComingSoonBadge, 
            monthlyBadge: ComingSoonBadge, 
            yearlyBadge: ComingSoonBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: '',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: '',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: false,

        },
        {
          id: 15,
          hasModal: false,
          category: "",
          productTitle: "Don't know What?",
          description: "by Elizabeth Ashley",
          cardImage: "",
          ontraportUrl: "",
          externalUrl: "",
          modalTitle: "",
          modalSubtitle: "",
          leftButton: "Click to check it out.",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, 
            freeBadge: ComingSoonBadge, 
            monthlyBadge: ComingSoonBadge, 
            yearlyBadge: ComingSoonBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPHJOOQ',
            monthlyCoupom: '20TPHUUG',
            yearlyCoupom: '30TPYAAY',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: false,
        },
        {
          id: 16,
          hasModal: false,
          category: "Business",
          productTitle: "Transformational Coaching",
          description: "by Melissa Holman",
          cardImage: "",
          ontraportUrl: "",
          externalUrl: "",
          modalTitle: "",
          modalSubtitle: "",
          leftButton: "Click to check it out.",
          modalImage: dropImage,
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, 
            freeBadge: ComingSoonBadge, 
            monthlyBadge: ComingSoonBadge, 
            yearlyBadge: ComingSoonBadge,
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPHJOOQ',
            monthlyCoupom: '20TPHUUG',
            yearlyCoupom: '30TPYAAY',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: false,
        },
        {
          id: 17,
          hasModal: false,
          category: "Surprise",
          productTitle: "GC Analysis",
          description: "Surprise",
          cardImage: gcAnalysisImg,
          ontraportUrl: "",
          externalUrl: "",
          modalTitle: "",
          modalSubtitle: "",
          leftButton: "Click to check it out.",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, //no discount
            freeBadge: ComingSoonBadge, //10 percentage
            monthlyBadge: ComingSoonBadge, //20 percentage monthly or trial
            yearlyBadge: ComingSoonBadge, //30 percentage + gift
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPHJOOQ',
            monthlyCoupom: '20TPHUUG',
            yearlyCoupom: '30TPYAAY',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: true,
        },
        {
          id: 18,
          hasModal: false,
          category: "Surprise",
          productTitle: "Dress To Progress",
          description: "by Janine",
          cardImage: "",
          ontraportUrl: "",
          externalUrl:"https://expo.dropsmarteo.com/janine-asmar/dress-to-progress",
          modalTitle: "",
          modalSubtitle: "",
          leftButton: "Click to check it out.",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],
          personalBadge: 
          {
            visitorBadge: SpecialGiftBadge, 
            freeBadge: SpecialGiftBadge, 
            monthlyBadge: SpecialGiftBadge, 
            yearlyBadge: SpecialGiftBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10TPHJOOQ',
            monthlyCoupom: '20TPHUUG',
            yearlyCoupom: '30TPYAAY',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '10% Off',
            monthlyCoupom: '20% Off',
            yearlyCoupom: '30% Off',
          },
          showOnDeck: false,
        },  
        {
          id: 19,
          hasModal: false,
          category: "Education", 
          productTitle: "Journals",
          description: "Coming soon!",
          cardImage: ExpoJournalsImg,
          ontraportUrl: "",
          externalUrl: "",
          modalSubtitle: "",
          leftButton: "",
          modalImage: "",
          modalVideo: "",
          reviews:
          [
            {
              reviewId: 1,
              reviewImg: "",
              reviewName: "",
              reviewDescription: "",
              reviewText: [
              {
                paragraphId: 1,
                paragraphText: ''
              },
              {
                paragraphId: 2,
                paragraphText: ''
              },
              ],
            }
          ],          
          personalBadge: 
          {
            visitorBadge: ComingSoonBadge, 
            freeBadge: ComingSoonBadge, 
            monthlyBadge: ComingSoonBadge, 
            yearlyBadge: ComingSoonBadge, 
          },
          personalCoupom: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          perkDescription: 
          {
            visitorCoupom: 'Subscribe to claim your cupom!',
            freeCoupom: '',
            monthlyCoupom: '',
            yearlyCoupom: '',
          },
          showOnDeck: true,
        },
      ],
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
    perksCardsData() {
      return this.perksAllCardsData.filter(function(u) {
        return u.showOnDeck;
      });
    },
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style scoped lang="scss">

</style>